import InputField from '@components/forms/input_field'

import {
  EMAIL_ERROR,
  GOOGLE_LANGUAGE_CODES,
  PERSONAL_EMAIL_FALLBACK,
  RECAPTCHA_ERROR
} from '../constants'

export function isFormValid(state) {
  return !state.emailError && !state.recaptchaError && !!state.recaptchaToken
}

export function responseHasEmailNotRegisteredError(data) {
  return data.errors && EMAIL_ERROR in data.errors
}

export function emailTldIsAcUk(email) {
  return email.endsWith('.ac.uk')
}

export function getEmailError(t, email) {
  if (InputField.EmailValidation(email)) {
    return t('e_email_invalid')
  }
  return ''
}

export function getCountry(country) {
  return country.toLowerCase()
}

export function getLanguageCode(country) {
  let language = 'en'
  GOOGLE_LANGUAGE_CODES.forEach((value, key) => {
    if (value.includes(getCountry(country))) {
      language = key
    }
  })
  return language
}

export function getStudentEmailCopy(t) {
  return t('e_email_use_personal_student') || PERSONAL_EMAIL_FALLBACK
}

export const repsonseHasRecaptchaError = (data) => {
  return data.error && data.error === RECAPTCHA_ERROR
}
